/**
 * Ennek az eszkoznek a push-feliratkozasa.
 *
 * ─── Miert kell tudni rola? ─────────────────────────────────────────────────
 *
 * Ugyanarrol az uzenetrol egy eszkoz ketfele is ertesulhet: push erkezik ra,
 * es a hatterben meg eletben levo lap is megkapja a WebSocketen. A kozos
 * `tag` elvileg osszevonna a kettot - az iOS viszont a `tag`-et figyelmen
 * kivul hagyja, es mindket ertesites megjelent egymas alatt.
 *
 * Ezert a szabaly nem az osszevonas, hanem a munkamegosztas: AMELYIK
 * eszkoz push-ra fel van iratkozva, ott a hatterbe kerult lap nem mutat
 * sajat rendszer-ertesitest - azt a push hozza el. A szerver pedig ebbol az
 * ertekbol (az eleljelben kuldve) tudja, melyik eszkozon latszik az ablak, es
 * oda nem kuld push-t.
 */

let endpoint: string | null = null;

export function setPushEndpoint(value: string | null): void {
  endpoint = value;
}

/** A feliratkozas vegpontja, vagy `null`, ha ezen az eszkozon nincs push. */
export function pushEndpoint(): string | null {
  return endpoint;
}

/**
 * A push hozza-e el ezen az eszkozon a rendszer-ertesitest.
 *
 * Engedely nelkul a feliratkozas hiaba el: a service worker nem tudna
 * megmutatni semmit, tehat a lapnak sincs mit atengednie.
 */
export function pushDeliversHere(): boolean {
  return (
    endpoint !== null &&
    typeof Notification !== 'undefined' &&
    Notification.permission === 'granted'
  );
}
